import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Purple_Btn.css";

const Purple_Btn = ({ btnText, disabled, type = "button",onClick,leftIcon,rightIcon, ...props }) => {
  return (
    <button
      className="Purple_Btn" 
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {leftIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={leftIcon} className="left_icon" />
        </div>
      )}

      <p className="btn_text">{btnText}</p>

      {rightIcon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={rightIcon} className="right_icon" />
        </div>
      )}
    </button>
  );
};

export default Purple_Btn;
